import SearchBar from "../../components/universal/SearchBar";
import Navbar from "../../components/universal/Navbar";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AddChurch from '../../screens/Churches/AddChurch'
import { Link } from "react-router-dom";
function AddField() {
   const { userInfo } = useSelector((state) => state.user);
   const location = useLocation(); // ✅ Add this line


   const { church } = location.state || {};
   const [selectedChurchName, setSelectedChurchName] = useState(() => {
     try {
       const saved = JSON.parse(localStorage.getItem("church") || "null");
       return saved?.churchName || "";
     } catch {
       return "";
     }
   });

   useEffect(() => {
     const onStorage = (e) => {
       if (e.key === "church") {
         try {
           const next = JSON.parse(e.newValue || "null");
           setSelectedChurchName(next?.churchName || "");
         } catch {
           setSelectedChurchName("");
         }
       }
     };
     const onChurchChange = (e) => {
       setSelectedChurchName(e?.detail?.churchName || "");
     };
     window.addEventListener("storage", onStorage);
     window.addEventListener("church:change", onChurchChange);
     return () => {
       window.removeEventListener("storage", onStorage);
       window.removeEventListener("church:change", onChurchChange);
     };
   }, []);

   const churchTitle = church?.churchName || selectedChurchName || "Church";

  return (
    <div className="App bg-[#191919] h-fit min-h-screen w-full overflow-x-hidden flex p-4">
      <Navbar />
      <div className="min-w-0 flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex min-w-0 flex-col gap-4 h-full">
          <SearchBar placeholder={"Search"} />


          <div className="flex min-w-0 items-center justify-between gap-4">
            <div className="min-w-0 truncate text-white text-2xl md:text-3xl font-semibold">
              {churchTitle}
            </div>
            <Link
              to="/churches/all"
              onClick={() => {
                const church = localStorage.getItem("ministry") || localStorage.getItem("church");
                if (church) {
                  localStorage.removeItem("ministry") || localStorage.removeItem("church");
                }
              }}
            >
              <button className="text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
                See All churches
              </button>
            </Link>
          </div>



          <div className="MAIN-CONTENT flex min-w-0 h-full gap-4 text-white">


                <div className="w-full min-w-0">
                  <AddChurch church={church} />
                </div>


          </div>
        </div>
      </div>
    </div>
  );
}

export default AddField;
